<template>
  <div class="Team Page__container">
    <div v-html="text" />
  </div>
</template>

<script>
export default {
  name: 'Team',
  computed: {
    text() {
      return this.$store.getters['app/pages']['options/equipe'][this.lang].text
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Team
  position relative

  p
    margin 0

  h2
    margin 40px 0

  h3
    color grad_blue1
    margin-top 20px
    margin-bottom 0px
</style>




// WEBPACK FOOTER //
// src/components/navigation/pages/Team.vue